import { render } from "./management.cattle.io.fleetworkspace.vue?vue&type=template&id=65cf37ff"
import script from "./management.cattle.io.fleetworkspace.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.fleetworkspace.vue?vue&type=script&lang=js"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__